<template>
  <form-drawer :title="type ? '编辑广告应用' : '新增广告应用'" :icon="type ? 'el-icon-edit-outline' : 'el-icon-plus'" :visible="dialogVisible" width="820px" :loading="saveLoading" @update:visible="handleDrawerVisible" @save="handleSaveDialog">
    <el-form :model="form" :rules="rules" ref="form" label-position="right" label-width="150px" size="small" class="drawer-horizontal-form">
      <el-form-item label="ID" prop="id">
        <el-input v-model.number="form.id" :disabled="type" placeholder="请输入 ID"></el-input>
      </el-form-item>
      <el-form-item label="应用名称" prop="name">
        <el-input v-model.trim="form.name" placeholder="请输入应用名称"></el-input>
      </el-form-item>
      <el-form-item label="AppKey" prop="appKey">
        <el-input v-model.trim="form.appKey" placeholder="请输入 AppKey"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret" prop="appSecret">
        <el-input v-model.trim="form.appSecret" placeholder="请输入 AppSecret"></el-input>
      </el-form-item>

      <el-form-item label="通知地址" prop="notifyUrl">
        <el-input v-model.trim="form.notifyUrl" placeholder="请输入通知地址 (NotifyUrl)"></el-input>
      </el-form-item>

      <!-- 表格化广告位编辑器 -->
      <el-form-item label="广告位配置" style="margin-top: 15px;">
        <div class="poses-table-container">
          <el-table :data="form.poses" stripe class="premium-table inline-edit-table" size="mini" max-height="300">
            <el-table-column label="广告位ID" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.posId" placeholder="广告位ID" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="广告位名称" min-width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.posName" placeholder="广告位名称" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="奖励名称" min-width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.rewardName" placeholder="奖励名称" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="奖励数量" min-width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.rewardAmount" placeholder="奖励数量" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="穿山甲广告位ID" min-width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.pangolinPosId" placeholder="穿山甲ID" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="穿山甲Secret" min-width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.pangolinAppSecret" placeholder="穿山甲Secret" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="腾讯广告位ID" min-width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.tencentPosId" placeholder="腾讯ID" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="优量汇Secret" min-width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.tencentSecret" placeholder="优量汇Secret" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" circle icon="el-icon-delete" plain @click="handleDeleteParams(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="poses-action-bar" style="margin-top: 10px;">
          <el-button size="mini" icon="el-icon-plus" @click="handleAddParams" class="btn-add-row">添加广告位行</el-button>
        </div>
      </el-form-item>
    </el-form>
  </form-drawer>
</template>

<script>
import api from '@/api/channel'
import FormDrawer from '@/components/FormDrawer/index.vue'

export default {
  name: 'ProductDialog',
  components: { FormDrawer },
  props: {
    dialogVisible: Boolean,
    posesData: Object
  },
  watch: {
    posesData: function (val) {
      this.type = !!val.name // true 为改变 false 为新增
      this.form = Object.assign({}, val)
    }
  },
  data () {
    return {
      form: {
        poses: [{ posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }]
      },
      type: '',
      saveLoading: false,
      rules: {
        id: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'change' }],
        name: [{ type: 'string', required: true, message: '请输入应用名称', trigger: 'blur' }],
        appKey: [{ type: 'string', required: true, message: 'appKey不能为空', trigger: 'blur' }],
        appSecret: [{ type: 'string', required: true, message: 'appSecret不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 关闭模态框
    handleCloseDialog () {
      if (this.$refs.form) this.$refs.form.clearValidate()
      this.$emit('handleCloseDialog', false)
    },
    handleDrawerVisible (visible) {
      if (!visible) this.handleCloseDialog()
    },
    // 保存数据
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          const params = Object.assign({}, this.form)
          if (params.poses) {
            let len = params.poses.length
            const arr = params.poses
            while (len--) {
              if (arr[len].posId === '') {
                arr.splice(len, 1)
              }
            }
          }
          params.poses = params.poses && params.poses.length > 0 ? JSON.stringify(params.poses) : null
          const f = !this.type ? api.postAdnetGames : api.putAdnetGames
          f(params).then(() => {
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.$emit('handleSaveDialog', false)
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    // 添加参数
    handleAddParams () {
      const params = { posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }
      if (!this.form.poses) {
        this.$set(this.form, 'poses', [])
      }
      this.form.poses.push(params)
    },
    // 删除参数
    handleDeleteParams (i) {
      this.form.poses.splice(i, 1)
    }
  }
}
</script>

<style scoped>
.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.poses-table-container {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
}

.premium-table {
  border: none !important;
}

.premium-table::before {
  display: none !important;
}

.inline-edit-table :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: #E2E8F0;
}

.inline-edit-table :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.btn-add-row {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: var(--primary-color) !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

.btn-add-row:hover {
  background-color: #F1F5F9 !important;
  border-color: #CBD5E1 !important;
}
</style>
